import { MobileSalesIndicatorSchedule } from '@toasttab/shared/src/interfaces/Navigation.d'

export const determinePhoneAvailability = (
  schedule: MobileSalesIndicatorSchedule[]
) => {
  if (!schedule) {
    return false
  }

  // Get the current day of week & time of day in Eastern time zone
  const now = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'America/New_York'
  }).format(new Date())

  const dayArr = now.split(' ')
  const dayOfWeek = dayArr[0]
  const currentTime = dayArr[1]

  // Get today's schedule for phone availability
  const todaySchedule: {
    enabled: boolean
    day: string
    endTime: string
    startTime: string
  } = schedule.find(
    (scheduleDay: { day: string }) => scheduleDay.day === dayOfWeek
  )
  // If phone support isn't enabled today, we can end here
  if (!todaySchedule?.enabled) {
    return false
  }

  // Narrow the startTime and endTime strings down to just the actual time
  const todayStart = todaySchedule.startTime.substring(
    todaySchedule.startTime.lastIndexOf('T') + 1,
    todaySchedule.startTime.lastIndexOf('-')
  )
  const todayEnd = todaySchedule.endTime.substring(
    todaySchedule.endTime.lastIndexOf('T') + 1,
    todaySchedule.endTime.lastIndexOf('-')
  )

  // Return true if the current time is between today's start and end times
  if (todayStart < currentTime && currentTime < todayEnd) {
    return true
  }
  // If not, return false
  return false
}
